export { default } from './styleFunctionSx';
export { unstable_createStyleFunctionSx } from './styleFunctionSx';
export { default as extendSxProp } from './extendSxProp';
export { default as unstable_defaultSxConfig } from './defaultSxConfig';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/styleFunctionSx/index.js
// module id = 100
// module chunks = 25